import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { SnackbarService } from '@markant-platform/shared/snackbar/feature';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  constructor(private readonly snackbarService: SnackbarService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 503) {
          this.snackbarService.showErrorSnackbarWithTransloco('error.serviceUnavailable');
        }
        throw err;
      })
    );
  }
}
